import { render, staticRenderFns } from "./UserMenuList.vue?vue&type=template&id=15ea732a&scoped=true&"
import script from "./UserMenuList.vue?vue&type=script&lang=js&"
export * from "./UserMenuList.vue?vue&type=script&lang=js&"
import style0 from "./UserMenuList.vue?vue&type=style&index=0&id=15ea732a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ea732a",
  null
  
)

export default component.exports